import { Component, computed, inject, input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { rxResource } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { DmBadge } from '@digitale-menschen/component-library-angular';
import { API_CONFIGURATION } from '@lexplus-environments';
import { MeinProfilRowComponent } from '@lexplus-shared-lib';
import { funktionenControllerGetAllDropdownOptionsV1 } from '@lexplus-user-api';
import { LexplusBenutzerDetailDto } from '@lexplus-authentication-api';

/**
 * The Funktionen a user holds, as a read-only row of «Persönliche Angaben».
 *
 * User app only: the admin app has no Funktionen. Provided as `MEIN_PROFIL_PERSONAL_EXTRA_ROWS`.
 * A user cannot change their own Funktionen, so they are badges rather than a picker.
 */
@Component({
  selector: 'lp-mein-profil-funktionen-row',
  imports: [DmBadge, MeinProfilRowComponent],
  templateUrl: './mein-profil-funktionen-row.component.html',
})
export class MeinProfilFunktionenRowComponent {
  private readonly httpClient = inject(HttpClient);
  private readonly apiConfiguration = inject(API_CONFIGURATION);

  public readonly details = input.required<LexplusBenutzerDetailDto>();

  private readonly optionsResource = rxResource({
    stream: () =>
      funktionenControllerGetAllDropdownOptionsV1(this.httpClient, this.apiConfiguration.baseUrlUser, {}).pipe(
        map((response) => response.body),
      ),
  });

  protected readonly assignedFunktionen = computed(() => {
    const ids = this.details().funktionIDs;
    const options = this.optionsResource.hasValue() ? this.optionsResource.value() : [];
    return options.filter((funktion) => funktion.intId !== undefined && ids.includes(funktion.intId));
  });

  protected readonly funktionenLabel = $localize`:@@common.funktionen:Funktionen`;
}
